import builder from '../builder';
import Phone from '../../streamline-icons/bold/phone.svg';

export default builder('IconPhoneBold', Phone);
